import request from '@/utils/request'
const baseUrl = process.env.VUE_APP_PURCHASE_API
import { addQueryToUrl } from '@/utils/utils'

// 查询招标详情接口
export function getBiddingProjectApi(orderId) {
  return request({
    url: baseUrl + `/monitor/v2/project/bidding-orders/${orderId}/detail`,
    method: 'get'
  })
}

// 查询电子标书详情接口
export function getMonitorKpbProjectDetailApi(
  orderId,
  kpbFileId,
  params,
  isNeedLoading = true
) {
  return request(
    {
      url:
        baseUrl +
        `/monitor/v2/project/bidding-orders/${orderId}/kpb-bidding-files/${kpbFileId}/detail`,
      method: 'get',
      params
    },
    isNeedLoading
  )
}

// 查询候选列表
export function getMonitorCandidateApi(orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/supplier-candidates`,
    method: 'get'
  })
}

// 查询候选详情
export function getMonitorCandidateDetailApi(orderId, candidateId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/supplier-candidates/${candidateId}/detail`,
    method: 'get'
  })
}
// 查询成交列表
export function getMonitorResultApi(orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/supplier-winners`,
    method: 'get'
  })
}

// 查询成交详情
export function getMonitorResultDetailApi(orderId, winnerId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/supplier-winners/${winnerId}/detail`,
    method: 'get'
  })
}

// 查看电子项目信息
export function getMonitorKpbProjectApi(orderId) {
  return request({
    url: baseUrl + `/monitor/v2/project/bidding-orders/${orderId}/kpb-project`,
    method: 'get'
  })
}

// 查询评委小组
export function getMonitorReviewListApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/kpb-project/reviewers/page`,
    method: 'get',
    params
  })
}

// 公告变更详情列表查询
export function getBidChangeListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/notice-changes/all/detail`,
    method: 'get'
  })
}

// 报名供应商分页查询
export function getSignUpSupplierApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/trades/signups/page`,
    method: 'get',
    params
  })
}

// 报名供应商详情
export function getSignUpSupplierDetailApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/trades/${tradeId}/signups/detail`,
    method: 'get'
  })
}

// 邀请供应商查询
export function getInviteSupplierApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/supplier-invites/page`,
    method: 'get',
    params
  })
}

// 登记项目详情查询接口
export function getBiddingRecordApi(registrationId) {
  return request({
    url: baseUrl + `/monitor/v2/project/registrations/${registrationId}/detail`,
    method: 'get'
  })
}

// 文件澄清列表查询
export function getBidFileClarifyListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/file-supplements`,
    method: 'get'
  })
}

// 查询文件澄清查阅日志
export function getBidFileClarifyLogApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/file-supplements/view-logs/page`,
    method: 'get',
    params
  })
}

// 下载招标文件
export function downloadBidFileApi(params) {
  return request({
    url: baseUrl + `/monitor/v2/project/bidding-orders/download-bidding-file`,
    method: 'get',
    params
  })
}

// 预览招标文件
export function previewBidFileApi(params) {
  return request({
    url: baseUrl + `/monitor/v2/project/bidding-orders/preview-bidding-file`,
    method: 'get',
    params
  })
}

// 获取成交详情
export function getResultDetailApi(orderId, winnerId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/supplier-winners/${winnerId}/supplier-notices`,
    method: 'get'
  })
}

// 下载通知书文件
export function downloadBidResultFileApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/download-notice-file`,
    method: 'get',
    params
  })
}

// 预览通知书文件
export function previewBidResultFileApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/preview-notice-file`,
    method: 'get',
    params
  })
}

// 下载投标文件
export function downloadApplyBidFileApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/download-bid-file`,
    method: 'get',
    params
  })
}

// 预览投标文件
export function previewApplyBidFileApi(params) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${params.orderId}/preview-bid-file`,
    method: 'get',
    params
  })
}

// 获取报告目录列表
export function getReviewReportCatalogListApi(orderId, reportId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/kpb-project/reports/${reportId}/catalogs`,
    method: 'get'
  })
}

// 查询最新的评标报告表
export function getReviewReportApi(orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/kpb-project/reports/last`,
    method: 'get'
  })
}

// 下载评标报告表
export function downloadReviewReportApi(orderId, reportId, catalogId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/kpb-project/reports/${reportId}/catalogs/${catalogId}/down`,
    method: 'get'
  })
}

// 下载评标报告汇总表
export function downloadAllReviewReportApi(params, orderId, reportId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/kpb-project/reports/${reportId}/catalogs/merge`,
    method: 'get',
    params
  })
}

// 查询招标文件查阅日志
export function getBidFileLogApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/monitor/v2/project/bidding-orders/${orderId}/bidding-files/view-logs/page`,
    method: 'get',
    params
  })
}

// 投标供应商-报名资料批量打包新增
export function downloadBidProjectSupplierInfoApi(orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/v2/project/bidding-orders/${orderId}/bid-suppliers/info-export`
    ),
    '_blank'
  )
}

// 项目一键归档
export function archiveFileApi(data, orderId, isNeedLoading = true) {
  return request(
    {
      url: baseUrl + `/monitor/v2/project/bidding-orders/${orderId}/to-file`,
      method: 'post',
      data
    },
    isNeedLoading
  )
}
